import React, { useState, useEffect } from "react";
import {
  CircularProgress,
  Typography,
  Grid,
  Backdrop,
  Box,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import "./sexyLoader.css";
import SvgComponent from "./svgComponent";
import { Dot } from "react-animated-dots";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  loaderText: {
    marginLeft: theme.spacing(0),
  },
  iconContainer: {
    width: "44px",
  },
  rocketIcon: {},
  backdrop: {
    position: "absolute",
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    backgroundColor: "rgba(0, 0, 0, 0.95)",
  },
}));

const SexyLoader = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return props.IsLoading ? (
    <>
      <Grid container>
        <Box>
          <Backdrop className={classes.backdrop} open={props.IsLoading}>
            <Grid item className={classes.iconContainer}>
              <CircularProgress size={20}></CircularProgress>
              {/* <SvgComponent className={classes.rocketIcon} /> */}
              {/* <RocketSVG width={50} height={50} /> */}
            </Grid>
            <Grid item>
              <Typography className={classes.loaderText} variant="overline">
                {t("PLEASE WAIT")}
                <Dot>.</Dot>
                <Dot>.</Dot>
                <Dot>.</Dot>
              </Typography>
            </Grid>
          </Backdrop>
        </Box>
        {props.children}
      </Grid>
    </>
  ) : (
    props.children
  );
};
export default SexyLoader;
